module.exports = __webpack_public_path__ + "media/images/audi-446fcdef81b4e1e96368dda13d437327.png";